import { create } from "zustand";

// The open board's stored team and owner, for editor menus that act on the
// stored doc (filing). Kept out of projectData, which saves and the dirty
// check read. Valid only while boardId matches the editor's projectId.
interface EditorBoardState {
  boardId: string | null;
  firmId: string | null;
  owner: string | null;
}

export const useEditorBoard = create<EditorBoardState>(() => ({
  boardId: null,
  firmId: null,
  owner: null,
}));

export const setEditorBoard = (
  boardId: string | null,
  firmId: string | null,
  owner: string | null,
) => useEditorBoard.setState({ boardId, firmId, owner });
